<template>
  <el-dialog
    :visible="!!editingProject"
    title="修改节点设置"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" label-width="100px">
      <el-form-item label="用户ID：" prop="userId">
        {{ detail.userId }}
      </el-form-item>
      <el-form-item label="节点地址：" prop="address">
        <el-input v-model="detail.address"></el-input>
      </el-form-item>
      <el-form-item label="节点名字：" prop="nodeName">
        <el-input v-model="detail.nodeName"></el-input>
      </el-form-item>
      <el-form-item label="开启时间：" prop="createTime">
        {{ detail.createTime | moment }}
      </el-form-item>
      <el-form-item label="节点人数">
        <el-input v-model="detail.userCount"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="description">
        <el-input v-model="detail.description"></el-input>
      </el-form-item>
      <el-form-item label="二维码：" prop="weChatImage">
        <upload v-model="detail.weChatImage" :data="{ platform: 1 }"></upload>
      </el-form-item>
      <el-form-item label="封面图：" prop="bannerImg">
        <upload v-model="detail.bannerImg" :data="{ platform: 1 }"></upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'userdividend',
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    ...mapState('setnode', ['editingProject'])
  },
  watch: {
    editingProject(val) {
      this.detail = { ...val };
    }
  },
  components: {
    Upload
  },
  methods: {
    ...mapMutations('setnode', ['setEditingProject']),
    ...mapActions('setnode', ['changeNode']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.changeNode({ ...this.detail, createTime: undefined }).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>
